import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray} from '@angular/forms';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';


export interface DialogData {
  idProductor: number;
  idPresol: number;
  ejercicio: number;
  idPrograma: number;
  idSubprograma: number;
  idConceptoDeApoyo: number;
  idRequisito: number;
  idDocumento: number;
}
@Component({
  selector: 'app-vincular-documento-expediente',
  templateUrl: './vincular-documento-expediente.component.html',
  styleUrls: ['./vincular-documento-expediente.component.css']
})
export class VincularDocumentoExpedienteComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<VincularDocumentoExpedienteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  onCancel(): void {
    this.dialogRef.close();
  }


  openAlert(title, text, action, color, direccion = null): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action,
        color
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (direccion === null) {
        console.log(result);
      } else {
        console.log(result);
      }
    });

   }

}
